import _ from "lodash";

export default {
    buildOptionFor(options, displayString = "All") {
        if (options.length < 1) {
            return [{value: "all", text: displayString}];
        }
        let result =
            displayString != null
                ? [{value: "all", text: displayString}] : [];

        _.forEach(options, function(value, key) {
            result.push({ value: key, text: value });
        });

        return result;
    }
};